/**
 * 文件说明:
 *
 * wx Sentry utils (具体配置看企业微信SDK文档)
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import * as Sentry from 'utils/sentry'
import {isWxFn, isWxworkFn} from '@huzan/hz-utils'
import {dispatch} from './dva'

export function isWxwork() {
    return isWxworkFn()
}

export function isWx() {
    return isWxFn()
}

export function getWx() {
    return window.wx
}

export function getWWOpenData() {
    return window.WWOpenData
}

export async function hzAgentConfigInit({configOption, agentConfigOption}) {
    try {
        if (isWxwork() || isWx()) {
            await wxConfig(configOption)
        }

        await agentConfig(agentConfigOption)

        const WWOpenData = getWWOpenData()

        if (WWOpenData?.on) {
            WWOpenData.on('sessionTimeout', (e) => {
                console.info('wx.WWOpenData sessionTimeout')
                dispatch({
                    type: 'auth/logout',
                })
                Sentry.withScope((scope) => {
                    scope.setTag('wx.WWOpenData', 'error')

                    Sentry.captureEvent({
                        message: 'wx.WWOpenData sessionTimeout',
                        level: 'info',
                        contexts: {
                            sessionTimeoutEvent: e,
                        },
                    })
                })
            })

            WWOpenData.on('error', (e) => {
                console.error('wx.WWOpenData error', e)
                Sentry.withScope((scope) => {
                    scope.setTag('wx.WWOpenData', 'error')
                    Sentry.captureException(e)
                })
            })
        }
    } catch (e) {
        console.error('hzAgentConfigInit error', e)
        Sentry.withScope((scope) => {
            scope.setTag('hzAgentConfigInit', 'error')
            Sentry.captureException(e)
        })
    }
}

export async function wxConfig(option) {
    return new Promise((resolve, reject) => {
        if (!getWx()?.wx) {
            resolve()
            return
        }

        const wx = getWx()
        wx.config(option)

        wx.ready((res) => {
            resolve(res)
        })

        wx.error((res) => {
            const err = new Error()
            err.message = res.errMsg
            err.wxError = res

            reject(err)
        })
    }).then(
        (res) => {
            console.info('wx.config success', res)

            return res
        },
        (error) => {
            console.error('wx.config fail', error)

            Sentry.withScope((scope) => {
                scope.setTag('wx.config', 'error')
                Sentry.captureException(error)
            })
        },
    )
}

export async function agentConfig(config) {
    return new Promise((resolve, reject) => {
        if (!getWx()?.agentConfig) {
            resolve()
            return
        }
        getWx().agentConfig({
            ...config,
            success: (res) => {
                resolve(res)
            },
            fail: (res) => {
                const err = new Error()
                if (res.errMsg.indexOf('function not exist') > -1) {
                    err.message = '版本过低请升级'
                } else {
                    err.message = res.errMsg
                }

                err.wxAgentError = res

                reject(err)
            },
        })
    }).then(
        (res) => {
            console.info('wx.agentConfig success', res)

            return res
        },
        (error) => {
            console.error('wx.agentConfig fail', error)

            Sentry.withScope((scope) => {
                scope.setTag('wx.agentConfig', 'error')
                Sentry.captureException(error)
            })
        },
    )
}
